import CallDetail from './pages/CallDetail.js'
import Main from './pages/Main.js'
import SmsDetail from './pages/SmsDetail.js'
import Header from './section/Header.js'
import Dialogs from './shared/Dialogs.js'
import { isPhoneNumberValid } from './shared/Utils.js'

const AppContainer = ({
  showMain,
  showCallDetail,
  showSmsDetail,
  component

}) => {

  let content = undefined
  let contextPhoneNumber = undefined
  if (showMain) {
    content =
      <Main
        {...component.state}
        container={component.container}
        setProvidedNumber={component.setProvidedNumber}
      />
  } else if (showCallDetail) {
    if (component.state.fullScreenNotification.event?.callType === 'inbound') {
      contextPhoneNumber = component.state.fullScreenNotification.event.callerNumber
    }
    else if (component.state.fullScreenNotification.event?.callType === 'outbound') {
      contextPhoneNumber = component.state.fullScreenNotification.event.calledNumber
    }
    content =
      <CallDetail
        {...component.state}
        call={component.state.fullScreenNotification.event}
        container={component.container}
        setProvidedNumber={component.setProvidedNumber}
      />
  } else if (showSmsDetail) {
    if (component.state.fullScreenNotification.event?.state === 'received' && isPhoneNumberValid(component.state.fullScreenNotification.event.sender)) {
      contextPhoneNumber = component.state.fullScreenNotification.event.sender
    }
    else if (isPhoneNumberValid(component.state.fullScreenNotification.event.recipient)) {
      contextPhoneNumber = component.state.fullScreenNotification.event.recipient
    }
    content =
      <SmsDetail
        {...component.state}
        sms={component.state.fullScreenNotification.event}
        container={component.container}
        setProvidedNumber={component.setProvidedNumber}
      />
  }

  return (
    <div
      className="app-container"
      onClick={component.disableFullScreenNotificationExpiration}
    >
      <Header
        {...component.state}
        container={component.container}
        stateData={component.stateData}
        openSettings={() => component.setState({ settingsOpened: true })}
        setProvidedNumber={component.setProvidedNumber}
        contextPhoneNumber={contextPhoneNumber}
        setOpenedSection={(value) => component.setState({ openedSection: value })}
        component={component}
      />
      {content}
      <Dialogs />
    </div>
  )

}

export default AppContainer